import { render, staticRenderFns } from "./AddNewQuestion.vue?vue&type=template&id=01407b6b&"
import script from "./AddNewQuestion.vue?vue&type=script&lang=js&"
export * from "./AddNewQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports